import React from 'react';
import MobileBottomSheet from './MobileBottomSheet';
import LayerPanel from '../Layers/LayerPanel';

export default function MobileLayersSheet({ isOpen, onClose, layers = [], layerManager, canvasManager, activeObject }) {
  return (
    <MobileBottomSheet isOpen={isOpen} onClose={onClose} title="Ebenen" height="50vh">
      <div style={{ padding: '0 8px 12px' }}>
        <p style={{ fontSize: '10px', color: 'var(--selenny-text-secondary, #999)', marginBottom: '6px', paddingLeft: '4px' }}>
          Ziehen zum Verschieben, Doppeltippen zum Umbenennen
        </p>
        <LayerPanel
          layers={layers}
          layerManager={layerManager}
          activeObject={activeObject}
          compact
        />
      </div>
    </MobileBottomSheet>
  );
}
